// ─────────────────────────────────────────────────────────────────────────────
// treeFilterOptions: In-Memory-Cache für /trees/filter-options.
//
// Die Liste wird in vielen Komponenten gebraucht (Trees-Filter, TreeDetail
// Edit-Dialog, MapView Neuer-Baum-Dialog, Import). Sie ändert sich aber selten
// (neue Orte/Baumarten/Eigentümer kommen nur durch neue Erfassungen dazu).
//
// Statt jedes Mal vom Server zu laden:
//   - Erster Aufruf: API → cache → returns
//   - Spätere Aufrufe: returns aus cache
//   - Per invalidate() nach neuem Baum / Edit den Cache leeren
//
// Cache überlebt Navigation, wird beim Tab-Close zurückgesetzt.
// ─────────────────────────────────────────────────────────────────────────────
import api from './api';

export type TreeFilterOptions = {
  baumarten: string[];
  orte: string[];
  strassen: string[];
  zustaende: string[];
  eigentuemer: string[];
};

const EMPTY: TreeFilterOptions = {
  baumarten: [], orte: [], strassen: [], zustaende: [], eigentuemer: [],
};

let cache: TreeFilterOptions | null = null;
let inflight: Promise<TreeFilterOptions> | null = null;

export async function getTreeFilterOptions(): Promise<TreeFilterOptions> {
  if (cache) return cache;
  if (inflight) return inflight;

  inflight = api.get('/trees/filter-options')
    .then(res => {
      cache = {
        baumarten:   res.data.baumarten   || [],
        orte:        res.data.orte        || [],
        strassen:    res.data.strassen    || [],
        zustaende:   res.data.zustaende   || [],
        eigentuemer: res.data.eigentuemer || [],
      };
      inflight = null;
      return cache;
    })
    .catch(() => {
      inflight = null;
      return EMPTY;
    });

  return inflight;
}

// Nach neuem Baum, Edit oder Import aufrufen – beim nächsten get() wird neu geladen.
export function invalidateTreeFilterOptions(): void {
  cache = null;
  inflight = null;
}
